// config.js — DEFAULTS, HOST_CONFIG, merged cfg, LOG, dbg

var DEFAULTS = {
  posthog_key:         'phc_QPYJY7CZK3tWeAEYTcqDr4JUsKDg1lRSJ3sQ0lzmkQx',
  posthog_host:        'https://p.probabl.ai',
  cookie_domain:       '.probabl.ai',
  no_track:            false,
  allow_file_protocol: false,
  hubspot_forms:       true,
  gtm_id:              'GTM-WKKX84LK',
  reo_id:              '460c80a5e0b7c04',
  banner_theme:        'light',
  person_profiles:     'always'
};
// Per-hostname overrides applied on top of DEFAULTS but below window.pbConfig.
// Allows a single theme installation to serve multiple HubSpot domains correctly.
var HOST_CONFIG = {
  // Main marketing site — uses the original (dark) banner theme
  'probabl.ai':               { banner_theme: 'default' },

  // HubSpot production
  'blog.probabl.ai':          { hubspot_forms: true },
  'hello.probabl.ai':         { hubspot_forms: true },
  'certification.probabl.ai': { hubspot_forms: true },
  'billing.probabl.ai':       { no_track: true, hubspot_forms: false },

  // Docs / product apps — no HubSpot forms
  'docs.skore.probabl.ai':           { hubspot_forms: false },
  'skore.probabl.ai':                { hubspot_forms: false },
  'skolar.probabl.ai':               { hubspot_forms: false },
  'scikit-learn-central.probabl.ai': { hubspot_forms: false },

  // No-track: preview environments and local dev
  '143437218.hubspotpreview-eu1.com': { no_track: true, hubspot_forms: false },
  'probabl.webflow.io':               { no_track: true, hubspot_forms: false },
  'probabl-2.webflow.io':             { no_track: true, hubspot_forms: false },
  '*.probabl.dev':                    { no_track: true, hubspot_forms: false },
  'localhost':                        { no_track: true, hubspot_forms: false },
  '127.0.0.1':                        { no_track: true, hubspot_forms: false },
  '0.0.0.0':                          { no_track: true, hubspot_forms: false }
};
var _pbCfg    = window.pbConfig || {};
var _host     = window.location.hostname;
var _hostCfg  = HOST_CONFIG[_host] || {};
// Fallback: match wildcard entries (*.example.com) by suffix
if (!HOST_CONFIG[_host]) {
  for (var _pattern in HOST_CONFIG) {
    if (_pattern.charAt(0) === '*') {
      var _suffix = _pattern.substring(1);
      if (_host.length > _suffix.length && _host.slice(-_suffix.length) === _suffix) {
        _hostCfg = HOST_CONFIG[_pattern];
        break;
      }
    }
  }
}
export var cfg = {};
var _hasProp = Object.prototype.hasOwnProperty;
for (var _k in DEFAULTS) {
  cfg[_k] = _hasProp.call(_pbCfg, _k)   ? _pbCfg[_k]
          : _hasProp.call(_hostCfg, _k)  ? _hostCfg[_k]
          : DEFAULTS[_k];
}
export var LOG = '[pb]';
var DEBUG = /[?&]pb-debug=1/.test(window.location.search);
export function dbg() {
  if (!DEBUG) { return; }
  var args = Array.prototype.slice.call(arguments, 0);
  console.log.apply(console, [LOG].concat(args));
}
